import React, { useEffect, useRef, useState } from "react";
import { MapPin, Loader2, Search } from "lucide-react";
import api from "../../lib/api";

const inputCls =
  "w-full rounded-xl border border-tara-teal/25 bg-white/85 px-4 py-3 pl-11 text-sm text-tara-ink placeholder:text-tara-muted/70 outline-none focus:border-tara-teal/60 transition-colors";

// Worldwide birth-place autocomplete (free geocoding, no key).
export default function PlaceSearch({ value, onSelect, placeholder = "Birth place (city)", testid = "place-search" }) {
  const [query, setQuery] = useState(value || "");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  useEffect(() => { setQuery(value || ""); }, [value]);

  const search = (q) => {
    setQuery(q);
    clearTimeout(timer.current);
    if (q.trim().length < 2) { setResults([]); return; }
    setLoading(true);
    timer.current = setTimeout(async () => {
      try {
        const r = await api.get(`/astro/places?q=${encodeURIComponent(q)}`);
        setResults(r.data || []);
        setOpen(true);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 320);
  };

  return (
    <div className="relative">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-tara-muted" />
      <input
        value={query}
        onChange={(e) => search(e.target.value)}
        onFocus={() => results.length && setOpen(true)}
        placeholder={placeholder}
        className={inputCls}
        data-testid={testid}
        autoComplete="off"
      />
      {loading && <Loader2 className="absolute right-4 top-1/2 -translate-y-1/2 h-4 w-4 animate-spin text-tara-teal" />}

      {open && results.length > 0 && (
        <ul className="glass-strong absolute z-30 mt-2 max-h-64 w-full overflow-y-auto rounded-2xl p-2" data-testid={`${testid}-results`}>
          {results.map((r, i) => (
            <li key={`${r.label}-${i}`}>
              <button
                type="button"
                onClick={() => { onSelect(r); setQuery(r.label); setOpen(false); }}
                className="flex w-full items-start gap-2.5 rounded-xl px-3 py-2.5 text-left text-sm text-tara-ink hover:bg-tara-teal/10 transition-colors"
                data-testid={`${testid}-option-${i}`}
              >
                <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-tara-vermilion" />
                <span>
                  {r.label}
                  <span className="block text-[11px] text-tara-muted">
                    {r.latitude.toFixed(2)}°, {r.longitude.toFixed(2)}° · {r.timezone}
                  </span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
